import BookIcon from '@mui/icons-material/Book';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import React, {useState} from 'react';
import {IoCloseCircleOutline} from 'react-icons/io5';
import {useNavigate, useParams} from 'react-router-dom';
import {Modal} from '../../components/modal/modal';
import {useAddepar} from '../../hooks/use-adepar';
import '../../styles/plaid.css';

export default function AddeparPage({user}) {
  const navigate = useNavigate();
  const {connection_id} = useParams();
  const {
    state: {connections},
    removeConnection,
    editConnection,
  } = useAddepar();

  const [editEntity, setEditEntity] = useState(false);
  const [editAccount, setEditAccount] = useState(false);
  const [mappingToEdit, setMappingToEdit] = useState(null);

  const connection = connections[connection_id] || {};
  const {account_mappings, entity_mappings, id} = connection;

  const handleRemoveEntityMapping = async mapping => {
    if (
      window.confirm('Are you sure you want to remove this entity mapping?')
    ) {
      const {success, error} = await editConnection({
        ...connection,
        entity_mappings: connection.entity_mappings.filter(m => m !== mapping),
      });

      if (!success) {
        window.alert('Failed to remove entity mapping: ' + error);
      }
    }
  };

  const handleRemoveAccountMapping = async mapping => {
    if (
      window.confirm('Are you sure you want to remove this account mapping?')
    ) {
      const {success, error} = await editConnection({
        ...connection,
        account_mappings: connection.account_mappings.filter(
          m => m !== mapping,
        ),
      });

      if (!success) {
        window.alert('Failed to remove account mapping: ' + error);
      }
    }
  };

  return (
    <div className='page-container'>
      <div
        className='flex-row justify-between'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          width: '100%',
        }}
      >
        <div style={{flexGrow: 1}}>
          {/* Entity Mappings Section */}
          {entity_mappings?.length > 0 && (
            <div style={{marginBottom: '24px'}}>
              <Typography variant='h6' style={{marginBottom: '12px'}}>
                Entity Mappings
              </Typography>
              <table style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th>Forest Entity Name</th>
                    <th>Addepar Entity Id</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {entity_mappings.map((item, index) => {
                    const {entity_id, entity_name} = item;
                    return (
                      <tr key={`entity-${index}`}>
                        <td>{entity_name}</td>
                        <td>{entity_id}</td>
                        <td>
                          <IconButton
                            aria-label='View Addepar mappings'
                            onClick={() =>
                              navigate(
                                `/addepar/${connection_id}/mappings/${entity_id}`,
                              )
                            }
                            title='Addepar mappings'
                          >
                            <BookIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setMappingToEdit(item);
                              setEditEntity(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              handleRemoveEntityMapping(item);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Account Mappings Section */}
          {/* {account_mappings?.length > 0 && (
            <div>
              <Typography variant='h6' style={{marginBottom: '12px'}}>
                Account Mappings
              </Typography>
              <table style={{width: '100%'}}>
                <thead>
                  <tr>
                    <th>Entity Name</th>
                    <th>Account Name</th>
                    <th>Owner ID</th>
                    <th>Entity ID</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {account_mappings.map((item, index) => {
                    const {account_name, entity_id, entity_name, owner_id} =
                      item;
                    return (
                      <tr key={`account-${index}`}>
                        <td>{entity_name}</td>
                        <td>{account_name}</td>
                        <td>{owner_id}</td>
                        <td>{entity_id}</td>
                        <td>
                          <IconButton
                            onClick={() => {
                              setMappingToEdit(item);
                              setEditAccount(true);
                            }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              handleRemoveAccountMapping(item);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )} */}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            marginLeft: '36px',
          }}
        >
          <button
            className='disconnect'
            style={{marginBottom: '16px'}}
            onClick={() => {
              setMappingToEdit(null);
              setEditEntity(true);
            }}
          >
            Add Entity
          </button>
          <button
            className='disconnect'
            style={{marginBottom: '16px'}}
            onClick={() => {
              setMappingToEdit(null);
              setEditAccount(true);
            }}
          >
            Add Account
          </button>
          <button
            className='disconnect'
            onClick={() => {
              navigate('/dashboard');
            }}
            style={{marginBottom: '16px'}}
          >
            Done
          </button>
          <button
            className='disconnect'
            onClick={async () => {
              const {success, error} = await removeConnection(id);

              if (success) {
                navigate('/dashboard');
              }
              if (error) {
                window.alert('Something went wrong. Try again later.');
              }
            }}
          >
            Disconnect
          </button>
        </div>
      </div>
      {editEntity && (
        <EntityMappingModal
          active={editEntity}
          setActive={setEditEntity}
          connection={connection}
          mappingToEdit={mappingToEdit}
          isEdit={!!mappingToEdit}
        />
      )}
      {editAccount && (
        <AccountMappingModal
          active={editAccount}
          setActive={setEditAccount}
          connection={connection}
          mappingToEdit={mappingToEdit}
          isEdit={!!mappingToEdit}
        />
      )}
    </div>
  );
}

// Entity Mapping Modal Component
const EntityMappingModal = ({
  active,
  setActive,
  connection,
  mappingToEdit,
  isEdit,
}) => {
  const {editConnection} = useAddepar();

  const [form, setForm] = useState({
    entity_name: mappingToEdit?.entity_name || '',
    entity_id: mappingToEdit?.entity_id || '',
  });

  const [error, setError] = useState(null);

  // Function to validate the entity mapping
  const validateEntityMapping = mapping => {
    return mapping.entity_name && mapping.entity_id;
  };

  const handleSubmit = async () => {
    try {
      if (!validateEntityMapping(form)) {
        setError('Please fill out all fields before completing');
        return;
      }

      const {success, error} = await editConnection({
        ...connection,
        entity_mappings: isEdit
          ? connection.entity_mappings.map(m =>
              m === mappingToEdit ? form : m,
            )
          : [...(connection.entity_mappings || []), form],
      });

      if (!success) {
        setError(error);
        return;
      }

      setActive(false);
    } catch (err) {
      window.alert('Something went wrong. Try again later.');
    }
  };

  return (
    <Modal active={active} setActive={setActive}>
      <div className='box'>
        <IconButton
          aria-label='close'
          onClick={() => setActive(false)}
          style={{position: 'absolute', top: 8, right: 8}}
        >
          <IoCloseCircleOutline />
        </IconButton>

        <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
          {isEdit ? 'Edit Entity Mapping' : 'Add New Entity Mapping'}
        </Typography>
        {error && (
          <Typography sx={{textAlign: 'center', color: 'red', marginTop: 2}}>
            {error}
          </Typography>
        )}
        <div className='box'>
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Entity Name:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Entity Name'
                  label='Entity Name'
                  placeholder='Entity Name'
                  value={form.entity_name}
                  type='text'
                  onChange={evt => {
                    setForm({...form, entity_name: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Entity ID:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Entity ID'
                  label='Entity ID'
                  placeholder='Entity ID'
                  value={form.entity_id}
                  type='text'
                  onChange={evt => {
                    setForm({...form, entity_id: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => setActive(false)}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// Account Mapping Modal Component
const AccountMappingModal = ({
  active,
  setActive,
  connection,
  mappingToEdit,
  isEdit,
}) => {
  const {editConnection} = useAddepar();

  const [form, setForm] = useState({
    account_name: mappingToEdit?.account_name || '',
    owner_id: mappingToEdit?.owner_id || '',
    entity_id: mappingToEdit?.entity_id || '',
    entity_name: mappingToEdit?.entity_name || '',
  });

  const [error, setError] = useState(null);

  // Function to validate the account mapping
  const validateAccountMapping = mapping => {
    return (
      mapping.account_name &&
      mapping.owner_id &&
      mapping.entity_id &&
      mapping.entity_name
    );
  };

  const handleSubmit = async () => {
    try {
      if (!validateAccountMapping(form)) {
        setError('Please fill out all fields before completing');
        return;
      }

      const {success, error} = await editConnection({
        ...connection,
        account_mappings: isEdit
          ? connection.account_mappings.map(m =>
              m === mappingToEdit ? form : m,
            )
          : [...(connection.account_mappings || []), form],
      });

      if (!success) {
        setError(error);
        return;
      }

      setActive(false);
    } catch (err) {
      window.alert('Something went wrong. Try again later.');
    }
  };

  return (
    <Modal active={active} setActive={setActive}>
      <div className='box'>
        <IconButton
          aria-label='close'
          onClick={() => setActive(false)}
          style={{position: 'absolute', top: 8, right: 8}}
        >
          <IoCloseCircleOutline />
        </IconButton>

        <Typography sx={{textAlign: 'center', fontSize: '22px'}}>
          {isEdit ? 'Edit Account Mapping' : 'Add New Account Mapping'}
        </Typography>
        {error && (
          <Typography sx={{textAlign: 'center', color: 'red', marginTop: 2}}>
            {error}
          </Typography>
        )}
        <div className='box'>
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Entity Name:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Entity Name'
                  label='Entity Name'
                  placeholder='Entity Name'
                  value={form.entity_name}
                  type='text'
                  onChange={evt => {
                    setForm({...form, entity_name: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Entity ID:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Entity ID'
                  label='Entity ID'
                  placeholder='Entity ID'
                  value={form.entity_id}
                  type='text'
                  onChange={evt => {
                    setForm({...form, entity_id: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Account Name:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Account Name'
                  label='Account Name'
                  placeholder='Account Name'
                  value={form.account_name}
                  type='text'
                  onChange={evt => {
                    setForm({...form, account_name: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          <br />
          <Grid container spacing={0}>
            <Grid
              item
              xs={6}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography>Owner ID:</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <TextField
                  id='Owner ID'
                  label='Owner ID'
                  placeholder='Owner ID'
                  value={form.owner_id}
                  type='text'
                  onChange={evt => {
                    setForm({...form, owner_id: evt.target.value});
                    setError('');
                  }}
                  variant='filled'
                />
              </FormControl>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={() => setActive(false)}
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              zIndex: 1,
              backgroundColor: '#c5c7c6',
              height: '30px',
              border: '0px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px 32px',
              margin: '16px 32px 0px 32px',
              color: 'black',
            }}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};
